"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SplitPriceLabel = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const material_1 = require("@mui/material");
const CheckRounded_1 = require("@mui/icons-material/CheckRounded");
const merge_1 = require("merge");
const react_1 = require("react");
const Format_1 = require("../Format");
const TotalPrice_style_1 = require("./TotalPrice.style");
var SplitPriceLabel;
(function (SplitPriceLabel) {
    SplitPriceLabel["total"] = "total";
    SplitPriceLabel["qlubDiscount"] = "qlubDiscount";
    SplitPriceLabel["leftToPay"] = "leftToPay";
    SplitPriceLabel["yourShare"] = "yourShare";
    SplitPriceLabel["fullyPaid"] = "fullyPaid";
    SplitPriceLabel["subTotal"] = "subTotal";
    SplitPriceLabel["tip"] = "tip";
    SplitPriceLabel["billAmount"] = "billAmount";
    SplitPriceLabel["youPaid"] = "youPaid";
    SplitPriceLabel["changeableAmount"] = "changeableAmount";
    SplitPriceLabel["payableAmount"] = "payableAmount";
    SplitPriceLabel["netSubTotal"] = "netSubTotal";
    SplitPriceLabel["paymentProcessingFee"] = "paymentProcessingFee";
})(SplitPriceLabel || (exports.SplitPriceLabel = SplitPriceLabel = {}));
const TotalPrice = (_a) => {
    var { priceData = [], footerText, Button, loading, qaFooterTextId, showOnly, currencyFormat } = _a, props = __rest(_a, ["priceData", "footerText", "Button", "loading", "qaFooterTextId", "showOnly", "currencyFormat"]);
    const data = (0, react_1.useMemo)(() => {
        var _a, _b;
        const total = priceData.filter((item) => item.label === 'total');
        const leftToPay = priceData.filter((item) => item.label === 'leftToPay');
        const isLeftToPayVisible = ((_a = total[0]) === null || _a === void 0 ? void 0 : _a.value) !== ((_b = leftToPay[0]) === null || _b === void 0 ? void 0 : _b.value);
        return {
            total,
            leftToPay,
            isLeftToPayVisible,
        };
    }, [priceData]);
    const { container, priceStyle, taxStyle } = (0, TotalPrice_style_1.default)();
    const { containerOverrides, priceOverrides, taxOverrides } = props;
    return ((0, jsx_runtime_1.jsxs)(material_1.Card, { "data-testid": "card", sx: (0, merge_1.merge)(true, container, containerOverrides), children: [priceData.map((item) => {
                if (item.label === 'qlubDiscount' && item.value === 0) {
                    return null;
                }
                if (item.label === 'leftToPay' && !data.isLeftToPayVisible) {
                    return null;
                }
                if (item.label === 'fullyPaid') {
                    return ((0, jsx_runtime_1.jsxs)(material_1.CardContent, { sx: (0, merge_1.merge)(true, priceStyle({ item }), priceOverrides), children: [item.text, (0, jsx_runtime_1.jsx)("span", { children: (0, jsx_runtime_1.jsx)(CheckRounded_1.default, {}) })] }, item.label));
                }
                const contents = ((0, jsx_runtime_1.jsxs)(material_1.CardContent, { "data-testid": "cardContent", sx: (0, merge_1.merge)(true, priceStyle({ item }), priceOverrides), children: [(0, jsx_runtime_1.jsx)("div", { "data-qa-id": item.qaTextId, children: item.text }), Button && item.label === 'yourShare' && Button, loading ? ((0, jsx_runtime_1.jsx)(material_1.Skeleton, { height: "16px", width: "72px", sx: { mt: '4px' } })) : (item.value !== undefined && ((0, jsx_runtime_1.jsx)(Format_1.default, { bold: true, value: String(item.value), currencyFormat: currencyFormat })))] }, item.label));
                if (!!showOnly && item.label === showOnly) {
                    return contents;
                }
                if (!showOnly)
                    return contents;
                return null;
            }), (0, jsx_runtime_1.jsx)(material_1.Typography, { "data-testid": "footer", sx: (0, merge_1.merge)(true, taxStyle, taxOverrides), "data-qa-id": qaFooterTextId, children: footerText })] }));
};
exports.default = TotalPrice;
